<div class="filters-row" style="display: flex; gap: 16px">
  <!-- Part Numbers Input -->
  <div class="filter-container">
    <label class="filter-label"  style="font-weight: 650; font-size: 15px;margin-bottom: 2px;border-radius: 8px;">{{ data?.name || 'Part Numbers' }}</label>
    <textarea
      [(ngModel)]="partNumbers"
      placeholder="Enter part numbers (comma, space, or newline separated)"
      class="input-field"
      rows="1"
    ></textarea>
  </div>

  <!-- Single Date Selection -->
  <!-- <div class="filter-container" *ngIf="data?.withDate">
    <label class="filter-label">Select Date</label>
    <input
      type="date"
      [(ngModel)]="selectedDate"
      class="input-field"
    />
  </div> -->

  <!-- Submit -->
  <div class="filter-container">
    <button style="font-weight: 650; font-size: 15px;" (click)="submit()">SUBMIT</button>
  </div>

  <!-- Reset -->

</div>
